<template>
  <main>
    <WelcomeModal></WelcomeModal>
    <div class="footer container-fluid">
      <div class="row">
        <div class="col-2 col-md-1">
          <img class="logo" src="../../assets/A_footer.png" />
        </div>
        <div class="col-10 col-md-11">
          <div class="row height-100">
            <div class="col-12 col-lg-3">
              <div class="contacts">
                <p>Gioielleria Italiana Srl</p>
                <p><a href="mailto:info@gioielleriaitaliana.com">info@gioielleriaitaliana.com</a></p>
                <p><a href="tel:+3901311715646">01311715646</a><a class="d-none d-lg-inline-block social-icon"
                    href="https://instagram.com/amadiamond_official?igshid=MjEwN2IyYWYwYw==" target="_blank">
                    <font-awesome-icon :icon="['fab', 'instagram']" />
                  </a>
                </p>
              </div>
            </div>
            <div class="col-12 col-lg-3 p-0">
              <div class="contacts">
                <p>Sede Amministrativa<span class="d-none d-lg-inline-block">:</span></p>
                <p>Via G. Donizetti, 14</p>
                <p>15048 Valenza (AL) Italia</p>
              </div>
            </div>
            <div class="col-12 col-lg-3 p-0">
              <div class="contacts">
                <p>Sede legale<span class="d-none d-lg-inline-block">:</span></p>
                <p>Via Poggio del sole superiore, 1/1</p>
                <p>Albissola Marina (SV) Italia</p>
              </div>
            </div>
            <div class="col-12 col-lg-3 p-0">
              <div class="contacts">
                <p>Responsabile Commerciale<span class="d-none d-lg-inline-block">:</span></p>
                <p>Francesco Sette</p>
                <p><a href="tel:+393493189978">+393493189978</a></p>
              </div>
              <div class="contacts d-block d-md-none">
                <div>
                  <a class="social-icon" target="_blank"
                    href="https://instagram.com/amadiamond_official?igshid=MjEwN2IyYWYwYw==">
                    <font-awesome-icon :icon="['fab', 'instagram']" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import WelcomeModal from '../WelcomeModal.vue';
export default {
  name: "FooterAma",
  components: { WelcomeModal }
}
</script>

<style scoped lang="scss">
.footer {
  background-color: var(--ama-black);
  color: var(--ama-white);
  padding: 0px 16px;
  padding-left: 0;

  a {
    text-decoration: none;
    color: var(--ama-white);
    cursor: pointer;
  }

  p {
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }
}

@media screen and (min-width: 0px) and (max-width: 992px) {
  .contacts {
    display: block !important;
    height: unset !important;
    margin-bottom: 0 !important;
  }

  .height-100 {
    text-align: center;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  p {
    display: inline-block;

    &:not(:last-child) {
      &::after {
        content: "\00a0-\00a0";
      }
    }
  }
}

.height-100 {
  height: 100%;
}

.logo {
  max-height: 130px;
  display: block;
}

.contacts {
  margin-bottom: 15px;
  margin-right: 15px;
  font-size: 14px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.social-icon {
  padding-left: 5px;
  font-size: 20px;
  line-height: 14px;
}

@media screen and (min-width: 0px) and (max-width: 600px) {
  p {
    font-size: 8px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

@media screen and (min-width: 0px) and (max-width: 992px) {
  .contacts {
    font-size: 10px;
  }
}
</style>
